import React, { memo, ReactElement } from "react";
import { SwiggyMoneyLoaderV4 } from "./v4";

function SwiggyMoneyLoadingScreen(): ReactElement {
    return <SwiggyMoneyLoaderV4 />;
}

export default memo(SwiggyMoneyLoadingScreen);
